import { CnamLookupRequestInputDTO } from "../model/input/cnam/cnamLookupRequestInputDTO";
import { CnamRequestSubmissionBulkInputDTO } from "../model/input/cnam/cnamRequestSubmissionBulkInputDTO";
import { CnamRequestSubmissionBusinessesInputDTO } from "../model/input/cnam/cnamRequestSubmissionBusinessesInputDTO";
import { CnamRequestSubmissionPersonInputDTO } from "../model/input/cnam/cnamRequestSubmissionPersonsInputDTO";
import {
  postCnamLookup,
  postUpdateCnamBulk,
  postUpdateCnamBusinesses,
  postUpdateCnamPersons,
} from "../service/cnamService";
import { cnamActions, CnamUpdateResponse } from "../store/cnamSlice";
import { errorActions } from "../store/errorSlice";
import logger from "../utils/logger";
import { MiddlewareType } from "./middlewareType";
import { handleRequestError } from "./middlewareUtils";

export const updateCnamPersonsMiddleware = (
  input: CnamRequestSubmissionPersonInputDTO
): MiddlewareType => {
  return (dispatch, getState) => {
    if (!getState().cnam.isLoading) {
      dispatch(cnamActions.setIsLoading(true));
      postUpdateCnamPersons(input)
        .then((res) => {
          dispatch(cnamActions.setIsLoading(false));

          dispatch(
            cnamActions.updateCnamResults({
              showModal: true,
              requestId: res.data.requestId,
              output: res.data.successfulTns,
              failedOutput: res.data.rejectedTns,
            })
          );
        })
        .catch((err) => {
          handleRequestError(dispatch, err);
          dispatch(cnamActions.setIsLoading(false));
        });
    }
  };
};

export const updateCnamBusinessesMiddleware = (
  input: CnamRequestSubmissionBusinessesInputDTO
): MiddlewareType => {
  return (dispatch, getState) => {
    if (!getState().cnam.isLoading) {
      dispatch(cnamActions.setIsLoading(true));
      postUpdateCnamBusinesses(input)
        .then((res) => {
          dispatch(cnamActions.setIsLoading(false));
          dispatch(
            cnamActions.updateCnamResults({
              showModal: true,
              requestId: res.data.requestId,
              output: res.data.successfulTns,
              failedOutput: res.data.rejectedTns,
            })
          );
        }) //TODO: IMPLEMENT
        .catch((err) => {
          handleRequestError(dispatch, err);
          dispatch(cnamActions.setIsLoading(false));
        });
    }
  };
};

export const updateCnamFileUploadMiddleware = (
  input: CnamRequestSubmissionBulkInputDTO
): MiddlewareType => {
  return (dispatch, getState) => {
    if (!getState().cnam.isLoading) {
      dispatch(cnamActions.setIsLoading(true));
      postUpdateCnamBulk(input)
        .then((res) => {
          dispatch(cnamActions.setIsLoading(false));
          dispatch(
            cnamActions.updateCnamResults({
              showModal: true,
              requestId: res.data.requestId,
              output: res.data.successfulTns,
              failedOutput: res.data.rejectedTns,
            })
          );
        }) //TODO: IMPLEMENT
        .catch((err) => {
          handleRequestError(dispatch, err);
          dispatch(cnamActions.setIsLoading(false));
        });
    }
  };
};

export const cnamLookupMiddleware = (
  input: CnamLookupRequestInputDTO
): MiddlewareType => {
  return (dispatch, getState) => {
    if (!getState().cnam.isLoading) {
      dispatch(cnamActions.setIsLoading(true));
      postCnamLookup(input)
        .then((res) => {
          dispatch(cnamActions.setCnamLookup(res.data.data));
          dispatch(cnamActions.setIsLoading(false));
        }) //TODO: IMPLEMENT
        .catch((err) => {
          handleRequestError(dispatch, err);
          dispatch(cnamActions.setIsLoading(false));
        });
    }
  };
};
